import { useContext } from 'react';

import { Container } from '@/components/ui/flexbox';
import { H3 } from '@/components/ui/Title';
import EnrollButton from '@/app/_components/core/EnrollButton';
import ClientContext from '@/contexts/client.context';

import { RelativeSection, Wrapper, ShapesWrapper, Subtitle, ButtonWrapper } from './styles';

const TriageCTA = ({ content }) => {
  const { title, subtitle, cta, isActive } = content;
  const { client } = useContext(ClientContext);

  if (!isActive) return null;

  return (
    <RelativeSection>
      <ShapesWrapper />
      <Container>
        <Wrapper>
          <H3>{title}</H3>
          <Subtitle>{subtitle}</Subtitle>
          <ButtonWrapper>
            <EnrollButton
              isActive={client.isActive}
              client={client}
              buttonLabel={cta?.label}
              buttonLocation="triageCTA"
              triage
            />
          </ButtonWrapper>
        </Wrapper>
      </Container>
    </RelativeSection>
  );
};

export default TriageCTA;
